import type {Language} from '@/types'

import React, {Component} from 'react'
import Modal from 'react-modal'
import {connect} from 'react-redux'
import GoX from 'react-icons/lib/go/x'
import {appSelectors, uiActions} from '@/store'
import {isEmpty} from 'ramda'

type Props = {
  title: string,
  children: any,
  l: Language,
  modalError: string,
  confirmMessage: string,
  message: string,
}

export class BaseModal extends Component<Props> {
  onCancel = () => {
    const modalType = this.props.title.split(' ')[0]
    this.props.onCancel()
    this.props.afterCancel()
    modalType === 'Import' || modalType === 'Sync' ? this.props.closeModal('import') : this.props.closeModal()
  }

  onConfirm = () => {
    this.props.onConfirm()
    // to make sure that the  api call return
    const modalInterval = setInterval(() => {
      if (isEmpty(this.props.modalError) && !isEmpty(this.props.confirmMessage)) {
        this.props.afterConfirm()
        this.props.closeModal()
        clearInterval(modalInterval)
      }
    }, 500)
  }

  renderCloseButton = () => this.props.showCloseButton
    ? (
      <button
        type="button"
        className="close"
        onClick={this.onCancel}
      >
        <GoX />
      </button>
    )
    : null

  renderCancel = () => this.props.showCancel
    ? (
      <button className='btn btn-danger' onClick={this.onCancel}>
        {this.props.l('Cancel')}
      </button>
    )
    : null

  renderConfirm = () => this.props.showConfirm
    ? (
      <button
        className='btn btn-success'
        disabled={this.props.preventConfirm}
        onClick={this.onConfirm}
      >
        {this.props.l('Confirm')}
      </button>
    )
    : null

  renderBody = () => {
    return (
      <div>
        {this.props.modalError
          ? <div className='modal-error'>{this.props.l(this.props.modalError)}</div>
          : null}
        {this.props.children
          ? <div className="modal-body">
            {this.props.children}
          </div>
          : null}
      </div>
    )
  }

  render = () => <Modal
    isOpen={this.props.shown}
    className={{
      base: 'modal-dialog',
      afterOpen: '',
      beforeClose: '',
    }}
    bodyOpenClassName="modal-open"
    overlayClassName={{
      base: 'modal fade',
      afterOpen: 'in modal-display',
      beforeClose: '',
    }}
    contentLabel="Modal"
  >
    <div className="modal-content">
      <div className="modal-header">
        {this.renderCloseButton()}
        <h4 className="modal-title">
          {this.props.title}
          {this.props.message
            ? <div>
              {this.props.message}
            </div>
            : null}
        </h4>
      </div>
      {this.renderBody()}
      <div className="modal-footer">
        {this.renderCancel()}
        {this.renderConfirm()}
      </div>
    </div>
  </Modal>
}

BaseModal.defaultProps = {
  showCloseButton: true,
  showCancel: true,
  showConfirm: true,
  onCancel: () => {},
  onConfirm: () => {},
  afterCancel: () => {},
  afterConfirm: () => {},
}

const mapStateToProps = (state, ownProps) => ({
  shown: state.ui.modal.shown,
  modalError: state.ui.modal.error,
  confirmMessage: state.ui.confirm.message,
  preventConfirm: ownProps.preventConfirm,
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  uiActions,
)(BaseModal)



// WEBPACK FOOTER //
// ./src/views/modals/base-modal.js